<template>
  <!-- 添加一个场景页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->

      <!-- 自动控制状态 -->
      <config-hang
        :switchState="config019PageData.triggerState"
        @click.native="showifBtnHandle"
      >
        <span slot="config_hang_ele2">自动控制状态</span>
        <img
          slot="config_hang_switchBtn_open"
          src="~assets/img/config/zhu_kai.png"
          alt
        />
        <img
          slot="config_hang_switchBtn_close"
          src="~assets/img/config/zhu_guan.png"
          alt
        />
      </config-hang>
      <!-- 自动触发值 -->
      <config-hang inputID="xiugaiName1">
        <span slot="config_hang_ele2">自动触发值</span>
        <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
        <img
          slot="config_hang_xiugai"
          src="~assets/img/config/xiugai.png"
          alt
        />
        <input
          type="text"
          slot="config_hang_input_right"
          id="xiugaiName1"
          :placeholder="showmaxTriggerValue"
          v-model="config019PageData.triggerValue"
        />
      </config-hang>

      <!-- 触发值前后滞后区间 -->
      <config-hang inputID="xiugaiName2">
        <span slot="config_hang_ele2">触发值前后滞后区间</span>
        <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
        <img
          slot="config_hang_xiugai"
          src="~assets/img/config/xiugai.png"
          alt
        />
        <input
          type="text"
          slot="config_hang_input_right"
          id="xiugaiName2"
          :placeholder="showmaxLagInterval"
          v-model="config019PageData.lagInterval"
        />
      </config-hang>
      <!-- 小于触发值得功能 -->
      <config-hang
        @click.native="
          SelectSceneBtnHandle('小于触发值触发的场景', 'lt019config')
        "
      >
        <span slot="config_hang_ele2">小于触发值触发的场景</span>
        <span slot="config_hang_ele3">{{ config019PageData.sceneNameLt }}</span>
        <img
          slot="config_hang_ele4"
          src="~assets/img/config/youjiantou.png"
          alt
        />
      </config-hang>

      <!-- 大于触发值得功能 -->
      <config-hang
        @click.native="
          SelectSceneBtnHandle('大于触发值触发的场景', 'gt019config')
        "
      >
        <span slot="config_hang_ele2">大于触发值触发的场景</span>
        <span slot="config_hang_ele3">{{ config019PageData.sceneNameGt }}</span>
        <img
          slot="config_hang_ele4"
          src="~assets/img/config/youjiantou.png"
          alt
        />
      </config-hang>
        <div
          v-if="$route.query.type === 'VOC' "
          class="xiaotishi_style"
        >注意:VOC的自动触发值和触发值前后滞后区间其实际值均为填写值除以100</div>

      <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">
        保存并返回
      </div>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
// import { configPageDataRequest } from 'views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js'
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  data() {
    return {
      ServeOneObjectinfo: {}, ////设备对象信息
      config019PageData: {}, ////019环境探测页面的配置数据
      maxTriggerValue: 1000, ////自动触发的最大值限定
      maxLagInterval: 250 ////自动触发的滞后区间值最大值限定
    }
  },
  computed: {
    showmaxTriggerValue() {
      return '0-' + this.maxTriggerValue
    },
    showmaxLagInterval() {
      return '0-' + this.maxLagInterval
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    showifBtnHandle() {
      // 开关状态按钮按下了
      if (this.config019PageData.triggerState === 1) {
        this.config019PageData.triggerState = 0
      } else {
        this.config019PageData.triggerState = 1
      }
    },
    SelectSceneBtnHandle(title, judge) {
      this.$router.push({
        path: 'selectOneScene',
        query: { title: title, type: judge }
      })
    },
    saveReturnBtnHandle() {
      if (!this.input019Judge()) return ////输入值得合法性判断
      ///设置环境探测通道参数 接口，获取数据
      this.$request({
        method: 'post',
        url: '/device/updateEnvironmentDetection',
        data: {
          token: this.$store.state.token,
          sceneIdGt: this.config019PageData.sceneIdGt,
          sceneIdLt: this.config019PageData.sceneIdLt,
          triggerId: this.config019PageData.triggerId,
          triggerState: this.config019PageData.triggerState,
          triggerValue: this.config019PageData.triggerValue,
          lagInterval: this.config019PageData.lagInterval
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data ////拿到服务器返回的数据结果
            // console.log(res.data.data)
            // this.$store.dispatch('asyUpdataconfig019PageData', res.data.data) ///异步提交信息到仓库
            // 跳转页面

            // 对要返回页面的回显数据更新
            if (this.$route.query.type === 'temp') {
              ///说明是温度的触发设置
              this.ServeOneObjectinfo.businessId1Desc =
                '(' +
                this.config019PageData.sceneNameLt +
                ')' +
                '(' +
                this.config019PageData.sceneNameGt +
                ')'
            } else if (this.$route.query.type === 'humidity') {
              ///说明是湿度的触发设置
              this.ServeOneObjectinfo.businessId2Desc =
                '(' +
                this.config019PageData.sceneNameLt +
                ')' +
                '(' +
                this.config019PageData.sceneNameGt +
                ')'
            } else if (this.$route.query.type === 'PM25') {
              ///说明是PM25的触发设置
              this.ServeOneObjectinfo.businessId3Desc =
                '(' +
                this.config019PageData.sceneNameLt +
                ')' +
                '(' +
                this.config019PageData.sceneNameGt +
                ')'
            } else if (this.$route.query.type === 'VOC') {
              ///说明是VOC的触发设置
              this.ServeOneObjectinfo.businessId4Desc =
                '(' +
                this.config019PageData.sceneNameLt +
                ')' +
                '(' +
                this.config019PageData.sceneNameGt +
                ')'
            }

            this.$router.go(-1)
            this.$showTipsToast(1, '设置成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    input019Judge() {
      if (this.config019PageData.triggerValue === '') {
        this.$toast('自动触发值不能为空！')
        return false
      } else if (this.config019PageData.lagInterval === '') {
        this.$toast('自动触发滞后区间值不能为空！')
        return false
      } else if (
        this.config019PageData.sceneIdGt === '' &&
        this.config019PageData.sceneIdLt === ''
      ) {
        this.$toast('至少选择一个触发场景！')
        return false
      }
      return true
    }
  },
  watch: {
    // 允许用户输入的最大触发值监测处理
    'config019PageData.triggerValue': function(val) {
      console.log(val)

      if (Number(val) > this.maxTriggerValue) {
        val = this.maxTriggerValue
      } else if (Number(val) < 0 || val === '') {
        val = 0
      }
      this.config019PageData.triggerValue = parseInt(val)
    },
    // 允许用户输入的最大触发值滞后区间值监测处理
    'config019PageData.lagInterval': function(val) {
      console.log(val)

      if (Number(val) > this.maxLagInterval) {
        val = this.maxLagInterval
      } else if (Number(val) < 0 || val === '') {
        val = 0
      }
      this.config019PageData.lagInterval = parseInt(val)
    }
  },
  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo ////一个对象的地址信息拿过来
    this.config019PageData = this.$store.state.configinfo.config019PageData ////019的配置信息拿过来
    console.log(this.config019PageData)
    /////配置触发值和滞后区间允许用户输入的最大值
    if (this.$route.query.type === 'temp') {
      ///说明是温度的触发设置
      this.maxTriggerValue = 50 ///用户允许输入的最大触发值
      this.maxLagInterval = 10 /////用户允许输入的最大滞后区间值
    } else if (this.$route.query.type === 'humidity') {
      ///说明是湿度的触发设置
      this.maxTriggerValue = 100 ///用户允许输入的最大触发值
      this.maxLagInterval = 20 /////用户允许输入的最大滞后区间值
    } else if (this.$route.query.type === 'PM25') {
      ///说明是PM25的触发设置
      this.maxTriggerValue = 1000 ///用户允许输入的最大触发值
      this.maxLagInterval = 250 /////用户允许输入的最大滞后区间值
    } else if (this.$route.query.type === 'VOC') {
      ///说明是VOC的触发设置
      this.maxTriggerValue = 500 ///用户允许输入的最大触发值
      this.maxLagInterval = 250 /////用户允许输入的最大滞后区间值
    }
  }
}
</script>

<style></style>
